module.exports = __webpack_public_path__ + "img/type_3.4236815b.png";